import { Component, Input } from '@angular/core';
import { Route } from 'src/app/models/route';
import { Profile } from 'src/app/models/profile';
import { getRouteColor, colorPatternByRouteSide } from 'src/app/utils/route';
import { Router } from '@angular/router';

@Component({
  selector: 'route-card',
  templateUrl: './route-card.component.html',
  styleUrls: ['./route-card.component.scss'],
})
export class RouteCardComponent {

  @Input() route: Route;
  @Input() profile: Profile;

  constructor(
    private router: Router,
  ) { }

  getColor() {
    return getRouteColor(this.route, this.profile);
  }

  getColorByRouteSide(position?: string) {
    if (!this.router || !this.router.url || !position) {
      return 'medium';
    }
    
    const colors = colorPatternByRouteSide[this.router.url] || {};

    return colors[position] || 'medium';
  }
}
